import { render, staticRenderFns } from "./WABAErrorCodes.vue?vue&type=template&id=35fe9a59&scoped=true"
import script from "./WABAErrorCodes.vue?vue&type=script&lang=js"
export * from "./WABAErrorCodes.vue?vue&type=script&lang=js"
import style0 from "./WABAErrorCodes.vue?vue&type=style&index=0&id=35fe9a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe9a59",
  null
  
)

export default component.exports